import { type IEligibleCandidateEntity } from './types';

/**
 * A candidate is "Sent" for a given onsite interview when that interview's id is
 * in their `invitedInterviewIds`. This is a business rule that drives both the
 * non-selectable "Sent" rows (the candidate list) and the invited count (the
 * invite section), so it lives here as a single source of truth — the two hooks
 * must never diverge on what "already invited to this interview" means.
 */
export const isInvitedToInterview = (
  candidate: IEligibleCandidateEntity,
  interviewId: string,
): boolean => candidate.invitedInterviewIds.includes(interviewId);

/** Ids of the candidates already invited to `interviewId`. */
export const selectInvitedCandidateIds = (
  candidates: IEligibleCandidateEntity[],
  interviewId: string,
): string[] => candidates.filter((c) => isInvitedToInterview(c, interviewId)).map((c) => c.id);
